import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import { createAPIEndpointRNR, EndpointSalesRNR } from "../../Services/RewardsAndRebateBook/RewardsAndRebateBook";
import storage from "../../Services/Storage";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";
import { toast } from "react-toastify";
import XLSX from "xlsx";
import { InputText } from "primereact/inputtext";
// import { InputTextarea } from "primereact/inputtextarea";
import { TabView, TabPanel } from "primereact/tabview";
import Loader from "../../Components/Loader";

// const channelTableHeaderStyle = {
//     textAlign: "left",
//     padding: "8px 12px",
//     fontSize: "11px",
//     fontWeight: 500,
//     color: "#718096",
//     textTransform: "uppercase",
//     letterSpacing: "0.03em",
// };

// const channelTableCellStyle = {
//     padding: "10px 12px",
//     verticalAlign: "top",
//     borderBottom: "1px solid #e5ebe9",
//     fontSize: "16px",
// };

const RewardsRebatebook = () => {
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, ""); // "yyyyMMdd"
    const auth = storage.getLocal("user");
    const [selectedStream, setSelectedStream] = useState([]);
    const [stream, setStream] = useState([]);
    const [selectedQuarter, setSelectedQuarter] = useState([]);
    const [quarter, setQuarter] = useState([]);
    const [allDBActivity, setAllDBActivity] = useState([]);
    const [planningStatus, setPlanningStatus] = useState([]);
    const [DBDetailActivity, setDBDetailActivity] = useState([]);
    const [DBDetailActivityHistory, setDBDetailActivityHistory] = useState([]);
    const [viewOutlet, setViewOutlet] = useState([]);
    const [viewOutletPopup, setViewOutletPopup] = useState(false);
    const [selectedOutlets, setSelectedOutlets] = useState([]);
    // const [selectedOutlets1, setSelectedOutlets1] = useState([]);
    const [KPIPopup, setKPIPopup] = useState(false);
    const [viewPopup, setViewPopup] = useState(false);
    const [saveConfirmPopup, setSaveConfirmPopup] = useState(false);
    const [outletPopUp, setOutletPopUp] = useState(false);
    const [selectedRowKey, setSelectedRowKey] = useState(null);
    const [KPI1_Approved, setKPI1_Approved] = useState("0");
    const [KPI2_Approved, setKPI2_Approved] = useState("0");
    const [KPI3_Approved, setKPI3_Approved] = useState("0");
    const [selectedUNQMapID, setSelectedUNQMapID] = useState("");
    // const [KPIPopup, setKPIPopup] = useState(false);
    const [KPI, setKPI] = useState({});
    const [viewItem, setViewItem] = useState([]);
    let uniqueNo = "Rewards_And_Rebate_Excel";
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [editingField, setEditingField] = useState(null);
    const [targetOfActi, setTargetOfActi] = useState(null);
    const [selectedActivityTitle, setSelectedActivityTitle] = useState(null);
    const [selectedUNQ_ID, setSelectedUNQ_ID] = useState(null);
    const [closerDate, setCloserDate] = useState(null);
    const [selectedRowData, setSelectedRowData] = useState(null);
    // const [originalCustomerCount, setOriginalCustomerCount] = useState(null);
    const [templateId, setTemplateId] = useState(null);
    const [bulkActionPopup, setBulkActionPopup] = useState(false);
    const [bulkActionRows, setBulkActionRows] = useState([]);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);
    const [pidValidatePopup, setPidValidatePopup] = useState(false);
    const [pidValidateRows, setPidValidateRows] = useState([]);
    const [pidValidateLoading, setPidValidateLoading] = useState(false);
    const [pidValidateActivityTitle, setPidValidateActivityTitle] = useState("");
    const [actualOutletMappingText, setActualOutletMappingText] = useState({});
    const [mechanicConsumerCounts, setMechanicConsumerCounts] = useState({});
    const [invalidActualOutletEntries, setInvalidActualOutletEntries] = useState([]);
    const [channelActualOutletCounts, setChannelActualOutletCounts] = useState({});
    const [pidValidateUnqId, setPidValidateUnqId] = useState(null);
    const [pidValidateChannelDescs, setPidValidateChannelDescs] = useState([]);
    const [pidChannelFilter, setPidChannelFilter] = useState("all");
    const [activePidTabIndex, setActivePidTabIndex] = useState(0);
    const [zeroValueWarningPopup, setZeroValueWarningPopup] = useState(false);
    const [bulkActionZeroWarningPopup, setBulkActionZeroWarningPopup] = useState(false);
    const [pidmappingValidationPopup, setPidmappingValidationPopup] = useState(false);
    // const [bulkActionZeroWarningPopup, setBulkActionZeroWarningPopup] = useState(false);

    const isNewTemplate = String(templateId) === "2";
    const canSubmitForApproval = allDBActivity[0]?.PLANNING_STATUS === "A" && closerDate === 0;

    // Mechanic/Consumer are plain counts (not mapped to real outlets in the system) —
    // every other admin-mapped channel (MCO, PCO, Anmol Ratan, etc.) shares one PID textbox per activity.
    const isMechanicOrConsumer = (channelDesc) =>
        ["mechanic", "consumer"].includes((channelDesc ?? "").toLowerCase().trim());

    const getActivityKey = (rowData) => String(rowData?.UNQ_ID);
    const getMechanicConsumerKey = (rowData) => `${rowData?.UNQ_ID}__${(rowData?.Channel_Desc ?? "").toLowerCase().trim()}`;

    const getTargetCount = (rowData) => {
        // Always return the original target count, not the current Customer_Count which might have been updated
        if (!rowData?._isOther) return Number(rowData?.Customer_Count) || 0;
        // For "other" channels, get the original target from the channel row
        return Number(rowData?._channelRow?.Customer_Count) || 0;
    };

    const handleActualOutletMappingChange = (rowData, value) => {
        const key = getActivityKey(rowData);
        setActualOutletMappingText((prev) => ({ ...prev, [key]: value }));

        // The mapping changed, so any previously validated-and-saved counts for this
        // activity's "other" channels are stale until PID Validate is run again.
        setChannelActualOutletCounts((prev) => {
            const next = { ...prev };
            Object.keys(next)
                .filter((k) => k.startsWith(`${key}__`))
                .forEach((k) => delete next[k]);
            return next;
        });

        // const entries = value.split(/[\n,]+/).map((s) => s.trim()).filter(Boolean);
        // const totalOtherTargetCount = bulkActionRows
        //     .filter((r) => String(r.UNQ_ID) === key && r._isOther)
        //     .reduce((sum, r) => sum + (Number(r.Customer_Count) || 0), 0);
        // if (totalOtherTargetCount > 0 && entries.length > totalOtherTargetCount) {
        //     toast.warning(
        //         `Actual Outlet Count (${entries.length}) cannot be more than Total Outlet Count (${totalOtherTargetCount}).`,
        //         {
        //             position: toast.POSITION.TOP_CENTER,
        //             pauseOnFocusLoss: false,
        //             closeButton: false,
        //             autoClose: 2500,
        //         }
        //     );
        // }
    };

    const handleMechanicConsumerCountChange = (rowData, value) => {
        const key = getMechanicConsumerKey(rowData);
        setMechanicConsumerCounts((prev) => ({ ...prev, [key]: value }));

        const numericValue = Number(value) || 0;

        // Mechanic/Consumer have no PID list — feed the typed count straight into the channel
        // history handleSubmit's payload builder reads Customer_ID / Customer_Count from.
        setDBDetailActivityHistory((prev) => {
            const channelRows = prev[rowData?.UNQ_ID] ?? [];
            const updatedChannelRows = channelRows.map((row) =>
                row.Channel_Desc === rowData?.Channel_Desc
                    ? { ...row, Actual_Customer_ID: "", Actual_Customer_Count: numericValue }
                    : row
            );
            return { ...prev, [rowData?.UNQ_ID]: updatedChannelRows };
        });

        const targetCount = Number(rowData?.Customer_Count) || 0;
        if (targetCount > 0 && numericValue > targetCount) {
            toast.warning(
                `Actual Outlet Count (${numericValue}) cannot be more than Total Outlet Count (${targetCount}) for ${rowData?.Channel_Desc}.`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2500,
                }
            );
        }
    };

    const fetchTemplateId = async (compId, qtrId, streamId) => {
        await createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetTemplateId}?strcompid=${compId}&strQtrId=${qtrId}&streamId=${streamId}`)
            .then((res) => {
                setTemplateId(res?.data?.Data?.[0]?.TEMPLATE_ID);
            })
            .catch((e) => {
                console.log("Error", e);
            });
    };

    const pageLoad = async () => {
        let filteredqtr;
        let stream;
        const today = new Date();
        // const currentQuarter = `${today.getFullYear()}2`;
        // debugger
        await createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetCastrolQuarter}?strTimeid=${formattedDate}`)
            .then((res) => {
                setQuarter(res.data.lstQuarter);
                filteredqtr = res.data.lstQuarter.filter((val) => {
                    return val.YEAR_QUARTER_VALUE === `${today.getFullYear()}${res.data.CurrentQuarter.substring(4, 5)}`;
                });
                setSelectedQuarter(filteredqtr[0]);
            })
            .catch((e) => {
                console.log("Error", e);
            });
        await createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetClosureDate}?strYear=${filteredqtr[0]?.YEAR_QUARTER_VALUE.substring(0, 4)}&strQuarter=${filteredqtr[0]?.YEAR_QUARTER_VALUE.substring(4, 5)}&closerdate=15`)
            .then((res) => {
                setCloserDate(res?.data?.Data[0]?.IS_ALLOWED);
            })
            .catch((e) => {
                console.log("Error", e);
            });
        await createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetScheme}`)
            .then((res) => {
                setStream(res.data.Data);
                stream = res.data.Data[0]?.Value;
                setSelectedStream(res.data.Data[0]);
            })
            .catch((e) => {
                console.log("Error", e);
            });
        createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetAllDBActivityData}?strcompid=${auth.CompId}&strQtrId=${filteredqtr[0].YEAR_QUARTER_VALUE}&streamId=${stream}`)
            .then((res) => {
                setAllDBActivity(res.data.Data);
                setPlanningStatus(res.data.Data[0]?.PLANNING_STATUS);
            })
            .catch((e) => {
                console.log("Error", e);
            });
        fetchTemplateId(auth.CompId, filteredqtr[0]?.YEAR_QUARTER_VALUE, stream);
    };
    useEffect(() => {
        pageLoad();
    }, []);

    const renderAction = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div className="d-inline" data-toggle="tooltip" data-placement="bottom" title="View">
                        <button className="grid-icon" onClick={() => { setViewItem([rowData]); setViewPopup(true); }}>
                            <Fa.FaEye />
                        </button>
                    </div>
                </div>
            </>
        );
    };
    const handleKPI = (rowData) => {
        const KPIObj = {
            KPI1: rowData?.KPI1,
            KPI2: rowData?.KPI2,
            KPI3: rowData?.KPI3
        };
        setKPI(KPIObj);
        setSelectedUNQMapID(rowData?.UNQ_ID);
        setKPIPopup(true);
    };
    const renderActionKPI = (rowData) => {

        return (
            <>
                <div className="action-icon">
                    <a onClick={() => handleKPI(rowData)}>Map</a>
                </div>
            </>
        );
    };
    const renderActionOutletView = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    {rowData?.OUTLET_VIEW_CHECKBOX === "Y" ? <div className="d-inline" data-toggle="tooltip" data-placement="bottom" title="View">
                        <button className="grid-icon" disabled={Number(rowData?.Channel_Discount) === 0} onClick={() => { handleMapOutlet(rowData); }}>
                            <Fa.FaEye />
                        </button>
                    </div> : <span><p>Outlet Mapping Not Enabled By Admin</p></span>}
                </div>
            </>
        );
    };

    const handleOutlet = async (rowdata) => {
        setSelectedActivityTitle(rowdata.Activity_Title);
        setSelectedUNQ_ID(rowdata.UNQ_ID);
        setTargetOfActi(rowdata?.Target_Activation);

        try {
            const res = await createAPIEndpointRNR().get(
                `${EndpointSalesRNR.GetAllDBActivityDetailData}?strcompid=${auth.CompId}&strQtrId=${selectedQuarter.YEAR_QUARTER_VALUE}&strCatDefId=${rowdata?.Category_ID}&strSeqId=${rowdata?.UNQ_ID}&strActivityTitle=${rowdata?.Activity_Title}&strStrmCode=${rowdata?.Stream_ID}&strChnlCode=${rowdata?.Channel_ID.toString()}&strChnlName=${rowdata?.Channel_Desc}&userId=${rowdata?.User_ID}&actiStatus=${rowdata?.PLANNING_STATUS}`
            );

            const mappedData = res.data?.Table0.map(item => ({
                ...item,
                OriginalCustomerCount: item.Customer_Count
            }));

            setDBDetailActivity(mappedData);
            setOutletPopUp(true);

            setDBDetailActivityHistory((prev) => ({
                ...prev,
                [rowdata.UNQ_ID]: mappedData
            }));
        } catch (e) {
            console.log("Error", e);
        }
    };


    const handleMapOutlet = async (rowdata) => {
        setSelectedRowKey(rowdata?.Channel_Desc);
        setSelectedRowData(rowdata?.Customer_Count);

        // Use Actual_Customer_ID if available, else fallback to Customer_ID
        // const previouslyMappedCustomerIDs =
        //     rowdata?.Actual_Customer_ID && rowdata?.Actual_Customer_ID.trim() !== ""
        //         ? rowdata?.Actual_Customer_ID.split("~")
        //         : rowdata?.Customer_ID?.split("~") ?? [];
        let previouslyMappedCustomerIDs = [];

        if (allDBActivity?.[0]?.PLANNING_STATUS === "A" && closerDate === 0) {
            previouslyMappedCustomerIDs =
                rowdata?.Actual_Customer_ID && rowdata?.Actual_Customer_ID.trim() !== ""
                    ? rowdata?.Actual_Customer_ID.split("~")
                    : rowdata?.Customer_ID?.split("~") ?? [];
        } else {
            previouslyMappedCustomerIDs = rowdata?.Actual_Customer_ID?.split("~") ?? [];
        }
        try {
            const res = await createAPIEndpointRNR().get(
                `${EndpointSalesRNR.GetAllDBActivityDetailData}?strcompid=${auth.CompId}&strQtrId=${selectedQuarter.YEAR_QUARTER_VALUE}&strCatDefId=${rowdata?.CATEGORY_DEF_ID}&strSeqId=${rowdata?.SEQ_ID}&strActivityTitle=${rowdata?.ACTIVITY_TITLE}&strStrmCode=${selectedStream?.Value}&strChnlCode=${rowdata?.Channel_Code.toString()}&strChnlName=${rowdata?.Channel_Desc}&userId=${auth?.UserId}&actiStatus=${planningStatus}`
            );

            const outletList = res.data?.Table1 ?? [];

            // Move previously selected outlets to the top
            const reorderedOutlets = [
                ...outletList.filter((val) => previouslyMappedCustomerIDs.includes(val.CustomerID)),
                ...outletList.filter((val) => !previouslyMappedCustomerIDs.includes(val.CustomerID)),
            ];

            setViewOutlet(reorderedOutlets);
            setViewOutletPopup(true);

            // Restore only previously mapped outlets
            const matchedOutlets = outletList.filter((val) =>
                previouslyMappedCustomerIDs.includes(val.CustomerID)
            );

            setSelectedOutlets(matchedOutlets);

            setDBDetailActivity((prev) =>
                prev.map((row) =>
                    row.Channel_Desc === rowdata.Channel_Desc
                        ? {
                            ...row,
                            Customer_Count: matchedOutlets.length,
                            // Save back in same field (`Actual_Customer_ID` if present, else `Customer_ID`)
                            Customer_ID: matchedOutlets.map((c) => c.CustomerID).join("~"),
                            Actual_Customer_ID:
                                rowdata?.Actual_Customer_ID && rowdata?.Actual_Customer_ID.trim() !== ""
                                    ? matchedOutlets.map((c) => c.CustomerID).join("~")
                                    : rowdata?.Actual_Customer_ID,
                        }
                        : row
                )
            );
        } catch (e) {
            console.error("Error", e);
        }
    };



    const openBulkActionDialog = async () => {
        setBulkActionPopup(true);
        setBulkActionLoading(true);
        try {
            const flatRows = [];
            // Accumulated from each channel's already-saved ActualcustomerUniquecode / Actualcustomercount
            // (the backend's previously-saved Actual mapping) — used to seed display state below so
            // read-only activities (canSubmitForApproval === false) still show prior data instead of blanks.
            const seededMechanicConsumerCounts = {};
            const seededChannelActualOutletCounts = {};
            const seededActualOutletCodesByActivity = {};

            for (const row of allDBActivity) {
                let chnlRows = DBDetailActivityHistory[row?.UNQ_ID];
                if (!chnlRows) {
                    const res = await createAPIEndpointRNR().get(
                        `${EndpointSalesRNR.GetAllDBActivityDetailData}?strcompid=${auth.CompId}&strQtrId=${selectedQuarter.YEAR_QUARTER_VALUE}&strCatDefId=${row?.Category_ID}&strSeqId=${row?.UNQ_ID}&strActivityTitle=${row?.Activity_Title}&strStrmCode=${row?.Stream_ID}&strChnlCode=${row?.Channel_ID?.toString()}&strChnlName=${row?.Channel_Desc}&userId=${row?.User_ID}&actiStatus=${row?.PLANNING_STATUS}`
                    );
                    chnlRows = res.data?.Table0 ?? [];
                    setDBDetailActivityHistory((prev) => ({ ...prev, [row?.UNQ_ID]: chnlRows }));
                }

                // Mechanic/Consumer go to the bottom — everything else (admin-mapped channels) stays on top.
                const otherChnlRows = (chnlRows ?? []).filter((c) => !isMechanicOrConsumer(c?.Channel_Desc));
                const mechanicConsumerChnlRows = (chnlRows ?? []).filter((c) => isMechanicOrConsumer(c?.Channel_Desc));

                [...otherChnlRows, ...mechanicConsumerChnlRows].forEach((c) => {
                    flatRows.push({
                        Category_Desc: row?.Category_Desc,
                        Activity_Title: row?.Activity_Title,
                        Max_Discount: row?.Max_Discount,
                        Channel_Desc: c?.Channel_Desc,
                        Channel_Discount: c?.Channel_Discount,
                        EST_BUDGET: row?.EST_BUDGET,
                        Customer_Count: c?.Customer_Count, // Original target count
                        UNQ_ID: row?.UNQ_ID,
                        Category_ID: row?.Category_ID,
                        _channelRow: c,
                        _originalTargetCount: c?.Customer_Count, // Store original target separately
                    });

                    if (isMechanicOrConsumer(c?.Channel_Desc)) {
                        if (c?.Actual_Customer_Count != null) {
                            seededMechanicConsumerCounts[getMechanicConsumerKey({ UNQ_ID: row?.UNQ_ID, Channel_Desc: c?.Channel_Desc })] =
                                String(c.Actual_Customer_Count);
                        }
                    } else {
                        seededChannelActualOutletCounts[`${row?.UNQ_ID}__${c?.Channel_Desc}`] = Number(c?.Actual_Customer_Count) || 0;
                        const codes = (c?.ActualCustomerUniqueCode ?? "").split("~").map((s) => s.trim()).filter(Boolean);
                        if (codes.length) {
                            seededActualOutletCodesByActivity[row?.UNQ_ID] = [
                                ...(seededActualOutletCodesByActivity[row?.UNQ_ID] ?? []),
                                ...codes,
                            ];
                        }
                    }
                });
            }

            // Group markers used by the column body templates — mirrors the ASM Planning Tool's
            // established "blank out repeated values" pattern (no PrimeReact rowspan needed).
            const activitySeen = new Set();
            const otherSeen = new Set();
            flatRows.forEach((r) => {
                r._isOther = !isMechanicOrConsumer(r.Channel_Desc);
                r._isFirstInActivity = !activitySeen.has(r.UNQ_ID);
                activitySeen.add(r.UNQ_ID);
                r._isFirstOther = r._isOther && !otherSeen.has(r.UNQ_ID);
                if (r._isFirstOther) otherSeen.add(r.UNQ_ID);
            });

            // Fill gaps only — never overwrite anything the user has already typed this session.
            setMechanicConsumerCounts((prev) => {
                const next = { ...prev };
                Object.entries(seededMechanicConsumerCounts).forEach(([key, value]) => {
                    if (!(key in next)) next[key] = value;
                });
                return next;
            });
            setChannelActualOutletCounts((prev) => {
                const next = { ...prev };
                Object.entries(seededChannelActualOutletCounts).forEach(([key, value]) => {
                    if (!(key in next)) next[key] = value;
                });
                return next;
            });
            setActualOutletMappingText((prev) => {
                const next = { ...prev };
                Object.entries(seededActualOutletCodesByActivity).forEach(([unqId, codes]) => {
                    if (!(unqId in next)) next[unqId] = codes.join("\n");
                });
                return next;
            });

            setBulkActionRows(flatRows);
        } catch (e) {
            console.log("Error", e);
            toast.error("Failed to load bulk action data.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setBulkActionLoading(false);
        }
    };

    const openPidValidateDialog = async (bulkRow) => {
        setPidValidatePopup(true);
        setPidValidateLoading(true);
        setPidValidateActivityTitle(bulkRow?.Activity_Title ?? "");
        setPidValidateUnqId(bulkRow?.UNQ_ID ?? null);
        setInvalidActualOutletEntries([]);
        setPidChannelFilter("all");
        setActivePidTabIndex(0);
        try {
            // The "Actual Outlet Mapping" textbox is shared across every admin-mapped ("other")
            // channel of this activity — PID Validate must check ALL of them, auto-detecting
            // which channel each typed PID actually belongs to. Mechanic/Consumer never reach here.
            const otherChannelRows = bulkActionRows.filter(
                (r) => String(r.UNQ_ID) === String(bulkRow?.UNQ_ID) && r._isOther
            );
            setPidValidateChannelDescs(Array.from(new Set(otherChannelRows.map((r) => r.Channel_Desc))));

            // Typed-entry PID validation only applies while the user can still submit for
            // approval. In view-only mode (canSubmitForApproval === false) we skip validating
            // the textbox contents against Table1 entirely and just show whatever was
            // previously saved as Actual — exactly as it was, no re-matching.
            const actualOutletMappingRaw = canSubmitForApproval
                ? (actualOutletMappingText[getActivityKey(bulkRow)] ?? "")
                : "";
            const actualOutletEntries = canSubmitForApproval
                ? actualOutletMappingRaw
                    .split(/[\n,]+/)
                    .map((s) => s.trim())
                    .filter(Boolean)
                : [];

            const matchedEntries = new Set();
            const allRows = [];
            let totalTargetCount = 0;

            for (const chRow of otherChannelRows) {
                const channelRow = chRow._channelRow;
                totalTargetCount += Number(chRow.Customer_Count) || 0;

                const res = await createAPIEndpointRNR().get(
                    `${EndpointSalesRNR.GetAllDBActivityDetailData}?strcompid=${auth.CompId}&strQtrId=${selectedQuarter.YEAR_QUARTER_VALUE}&strCatDefId=${channelRow?.CATEGORY_DEF_ID}&strSeqId=${channelRow?.SEQ_ID}&strActivityTitle=${channelRow?.ACTIVITY_TITLE}&strStrmCode=${selectedStream?.Value}&strChnlCode=${channelRow?.Channel_Code?.toString()}&strChnlName=${channelRow?.Channel_Desc}&userId=${auth?.UserId}&actiStatus=${planningStatus}`
                );
                const outlets = res.data?.Table1 ?? [];

                // Target outlets — the set ASM originally mapped onto this channel.
                const targetCustomerIds = (channelRow?.Customer_ID ?? "")
                    .split("~").map((s) => s.trim()).filter(Boolean);
                // Names line up positionally with Customer_ID (both '~'-joined) — used as a
                // display fallback for any target PID the outlet master doesn't return below.
                const targetCustomerNames = (channelRow?.CustomerName ?? "")
                    .split("~").map((s) => s.trim());
                // Target PIDs (CustomerUniqueCode) for display
                const targetCustomerPids = (channelRow?.CustomerUniqueCode ?? "")
                    .split("~").map((s) => s.trim());

                // Actual outlets already saved, plus typed entries that resolve to THIS channel's outlet list.
                const savedActualCustomerIds = (channelRow?.Actual_Customer_ID ?? "")
                    .split("~").map((s) => s.trim()).filter(Boolean);
                const savedActualCustomerNames = (channelRow?.ActualCustomerName ?? "")
                    .split("~").map((s) => s.trim());
                const savedActualCustomerPids = (channelRow?.ActualCustomerUniqueCode ?? "")
                    .split("~").map((s) => s.trim());

                const validTypedCustomerIds = [];
                if (canSubmitForApproval) {
                    actualOutletEntries.forEach((entry) => {
                        const match = outlets.find((o) =>
                            entry.toLowerCase() === String(o?.CustomerName ?? "").trim().toLowerCase() ||
                            entry === String(o?.CustomerUniqueCode ?? "").trim() ||
                            entry === String(o?.CustomerID ?? "").trim()
                        );
                        if (match) {
                            matchedEntries.add(entry);
                            validTypedCustomerIds.push(String(match.CustomerID));
                        }
                    });
                }

                // While submitting, "Actual" means exactly what the distributor typed in the
                // textbox this session, validated against Table1 — NOT merged with whatever was
                // previously saved on the backend. (Typing 10 PIDs and seeing 18/31 come back was
                // this merge silently pulling in the old saved Actual_Customer_ID alongside the
                // new typed ones.) In view-only mode there's nothing typed to validate, so we
                // just show the previously saved Actual as-is.
                const actualCustomerIds = canSubmitForApproval
                    ? Array.from(new Set(validTypedCustomerIds))
                    : Array.from(new Set(savedActualCustomerIds));

                // FIX: previously, any target/actual PID that wasn't present in this channel's
                // `outlets` (Table1) response was silently dropped — never pushed into `allRows`,
                // never counted. Because Anmol Ratan and RETAIL (Excluding AR) share the same
                // Channel_Code, Table1 for one channel can come back without every PID that
                // legitimately belongs to that channel's saved Customer_ID list, so counts like
                // 31 -> 13 happened. We now track which target/actual IDs got matched against
                // `outlets`, and add fallback rows (sourced from the channel row's own saved
                // Customer_ID / Actual_Customer_ID lists) for anything that didn't match, so
                // nothing is lost from the Target/Actual counts.
                const handledTargetIds = new Set();
                const handledActualIds = new Set();

                outlets.forEach((o) => {
                    const outletId = String(o?.CustomerID ?? "");
                    const outletUniqueCode = String(o?.CustomerUniqueCode ?? "");
                    const isTarget = targetCustomerIds.includes(outletId) || targetCustomerIds.includes(outletUniqueCode);
                    const isActual = actualCustomerIds.includes(outletId) || actualCustomerIds.includes(outletUniqueCode);

                    if (isTarget) {
                        const matchedTargetId = targetCustomerIds.find((t) => t === outletId || t === outletUniqueCode);
                        if (matchedTargetId) handledTargetIds.add(matchedTargetId);
                    }
                    if (isActual) {
                        const matchedActualId = actualCustomerIds.find((t) => t === outletId || t === outletUniqueCode);
                        if (matchedActualId) handledActualIds.add(matchedActualId);
                    }

                    // Helper function to remove PID from outlet name
                    const cleanOutletName = (name) => {
                        if (!name) return "";
                        const nameStr = String(name).trim();
                        // Remove PID in parentheses at the end (e.g., "BHARADWAJA AUTOMOBILES(5000030038)" -> "BHARADWAJA AUTOMOBILES")
                        return nameStr.replace(/\([^)]*\)\s*$/, "").trim();
                    };

                    let category = null;
                    if (isTarget && isActual) category = "matched";
                    else if (isActual) category = "addedByDistributor";
                    else if (isTarget) category = "pendingAsm";
                    if (category) {
                        allRows.push({
                            channelDesc: chRow.Channel_Desc,
                            CustomerID: o?.CustomerID,
                            TargetOutletName: isTarget ? cleanOutletName(o?.CustomerName) : "",
                            TargetPID: isTarget ? (String(o?.CustomerUniqueCode ?? "").trim()) : "",
                            ActualOutletName: isActual ? cleanOutletName(o?.CustomerName) : "",
                            ActualPID: isActual ? (String(o?.CustomerUniqueCode ?? "").trim()) : "",
                            category,
                        });
                    }
                });

                // Fallback: targets not present in `outlets` — still surfaced using the saved
                // Customer_ID / CustomerName lists so the Target/Total counts stay accurate.
                // Helper function to remove PID from outlet name
                const cleanOutletName = (name) => {
                    if (!name) return "";
                    const nameStr = String(name).trim();
                    return nameStr.replace(/\([^)]*\)\s*$/, "").trim();
                };

                targetCustomerIds.forEach((tid, idx) => {
                    if (handledTargetIds.has(tid)) return;
                    const isActualToo = actualCustomerIds.includes(tid);
                    if (isActualToo) handledActualIds.add(tid);
                    allRows.push({
                        channelDesc: chRow.Channel_Desc,
                        CustomerID: tid,
                        TargetOutletName: cleanOutletName(targetCustomerNames[idx] || ""),
                        TargetPID: targetCustomerPids[idx] || "",
                        ActualOutletName: isActualToo ? cleanOutletName(targetCustomerNames[idx] || "") : "",
                        ActualPID: isActualToo ? (targetCustomerPids[idx] || "") : "",
                        category: isActualToo ? "matched" : "pendingAsm",
                    });
                });

                // Fallback: previously-saved actuals not present in `outlets` and not already
                // covered by a target fallback row above.
                actualCustomerIds.forEach((aid) => {
                    if (handledActualIds.has(aid) || targetCustomerIds.includes(aid)) return;
                    const nameIdx = savedActualCustomerIds.indexOf(aid);
                    const cleanOutletName = (name) => {
                        if (!name) return "";
                        const nameStr = String(name).trim();
                        return nameStr.replace(/\([^)]*\)\s*$/, "").trim();
                    };
                    allRows.push({
                        channelDesc: chRow.Channel_Desc,
                        CustomerID: aid,
                        TargetOutletName: "",
                        TargetPID: "",
                        ActualOutletName: nameIdx >= 0 ? cleanOutletName(savedActualCustomerNames[nameIdx] || "") : "",
                        ActualPID: nameIdx >= 0 ? (savedActualCustomerPids[nameIdx] || "") : "",
                        category: "addedByDistributor",
                    });
                });
            }

            // Entries typed by the distributor that never matched a real outlet on ANY channel
            // of this activity — kept aside for display instead of being silently dropped.
            const invalidEntries = actualOutletEntries.filter((entry) => !matchedEntries.has(entry));
            setInvalidActualOutletEntries(invalidEntries);

            const categoryRank = { matched: 0, addedByDistributor: 1, pendingAsm: 2 };
            allRows.sort((a, b) => categoryRank[a.category] - categoryRank[b.category]);

            const actualCount = allRows.filter((r) => r.category === "matched" || r.category === "addedByDistributor").length;
            if (actualCount > totalTargetCount && totalTargetCount > 0) {
                toast.warning(
                    `Actual Outlet Count (${actualCount}) cannot be more than Total Outlet Count (${totalTargetCount}).`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2500,
                    }
                );
            }

            setPidValidateRows(allRows);
        } catch (e) {
            console.log("Error", e);
            toast.error("Failed to load outlet mapping.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setPidValidateLoading(false);
        }
    };

    const getPidChannelViolations = () => {
        const countsByChannel = {};
        pidValidateRows.forEach((r) => {
            if (!countsByChannel[r.channelDesc]) countsByChannel[r.channelDesc] = { target: 0, actual: 0 };
            if (r.category === "matched" || r.category === "pendingAsm") countsByChannel[r.channelDesc].target += 1;
            if (r.category === "matched" || r.category === "addedByDistributor") countsByChannel[r.channelDesc].actual += 1;
        });
        return Object.entries(countsByChannel)
            .filter(([, counts]) => counts.actual > counts.target)
            .map(([channelDesc, counts]) => ({ channelDesc, ...counts }));
    };

    const warnPidChannelViolations = (violations) => {
        toast.warning(
            `Actual Outlet Count cannot be more than Target Outlet Count for: ${violations.map((v) => `${v.channelDesc} (${v.actual} > ${v.target})`).join(", ")}.`,
            {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            }
        );
    };

    const handleClosePidValidate = () => {
        const violations = getPidChannelViolations();
        if (violations.length > 0) {
            warnPidChannelViolations(violations);
            return;
        }
        setPidValidatePopup(false);
    };

    const handleSavePidValidation = () => {
        const violations = getPidChannelViolations();
        if (violations.length > 0) {
            warnPidChannelViolations(violations);
            return;
        }
        const countsByChannel = {};
        const customerIdsByChannel = {};
        pidValidateRows.forEach((r) => {
            if (r.category === "matched" || r.category === "addedByDistributor") {
                countsByChannel[r.channelDesc] = (countsByChannel[r.channelDesc] ?? 0) + 1;
                customerIdsByChannel[r.channelDesc] = [...(customerIdsByChannel[r.channelDesc] ?? []), String(r.CustomerID)];
            }
        });

        setChannelActualOutletCounts((prev) => {
            const next = { ...prev };
            pidValidateChannelDescs.forEach((channelDesc) => {
                next[`${pidValidateUnqId}__${channelDesc}`] = countsByChannel[channelDesc] ?? 0;
            });
            return next;
        });

        // Persist the confirmed (Matched + Added by Distributor, Pending ASM Selection excluded)
        // outlet mapping onto the channel history handleSubmit's payload builder already reads
        // Customer_ID / Customer_Count from — no changes needed there.
        setDBDetailActivityHistory((prev) => {
            const channelRows = prev[pidValidateUnqId] ?? [];
            const updatedChannelRows = channelRows.map((row) => {
                if (!pidValidateChannelDescs.includes(row.Channel_Desc)) return row;
                const customerIds = customerIdsByChannel[row.Channel_Desc] ?? [];
                return {
                    ...row,
                    Actual_Customer_ID: customerIds.join("~"),
                    Actual_Customer_Count: customerIds.length,
                    // Keep original Customer_Count (target) unchanged
                };
            });
            return { ...prev, [pidValidateUnqId]: updatedChannelRows };
        });

        setPidValidatePopup(false);
    };

    const renderActionOUTLET = (rowData) => {

        return (
            <>
                <div className="action-icon">
                    <a onClick={() => handleOutlet(rowData)}>Outlet</a>
                </div>
            </>
        );
    };

    const handleDownload = () => {
        createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.DownloadExcel}?CompId=${auth.CompId}&QtrId=${selectedQuarter.YEAR_QUARTER_VALUE}&StreamId=${selectedStream.Value}`)
            .then((val) => {
                if (val.data.Data.length > 0) {
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(val.data.Data);
                    XLSX.utils.book_append_sheet(wb, ws, uniqueNo);
                    XLSX.writeFile(wb, `${uniqueNo}.xlsx`);
                }
                else {
                    toast.warning(
                        "No data available.",
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                }
                setLoadingExcel(false);
            })
            .catch((error) => {
                setLoadingExcel(false);
                toast.error("Something Went Wrong. Please Contact Helpdesk.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });

                console.log(error);
            });
    };

    const handleQuarter = async (e) => {
        setSelectedQuarter(e);
        let qtr;
        if (selectedQuarter?.YEAR_QUARTER_VALUE == "20262") {
            qtr = 2;
        } else {
            qtr = e?.YEAR_QUARTER_VALUE.substring(4, 5);
        }
        await createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetAllDBActivityData}?strcompid=${auth.CompId}&strQtrId=${e.YEAR_QUARTER_VALUE == "ALL" ? "" : e.YEAR_QUARTER_VALUE}&streamId=${selectedStream.Text}`)
            .then((res) => {
                setAllDBActivity(res.data.Data);
                setPlanningStatus(res.data.Data[0]?.PLANNING_STATUS);
            })
            .catch((e) => {
                console.log("Error", e);
            });
        await createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetClosureDate}?strYear=${e.YEAR_QUARTER_VALUE.substring(0, 4)}&strQuarter=${qtr}&closerdate=15`)
            .then((res) => {
                setCloserDate(res?.data?.Data[0]?.IS_ALLOWED);
            })
            .catch((e) => {
                console.log("Error", e);
            });
        fetchTemplateId(auth.CompId, e.YEAR_QUARTER_VALUE, selectedStream.Text);
    };
    const handleStream = async (e) => {
        setSelectedStream(e);
        createAPIEndpointRNR()
            .get(`${EndpointSalesRNR.GetAllDBActivityData}?strcompid=${auth.CompId}&strQtrId=${selectedQuarter.YEAR_QUARTER_VALUE}&streamId=${e.Text}`)
            .then((res) => {
                setAllDBActivity(res.data.Data);
                setPlanningStatus(res.data.Data[0]?.PLANNING_STATUS);
            })
            .catch((e) => {
                console.log("Error", e);
            });
        fetchTemplateId(auth.CompId, selectedQuarter.YEAR_QUARTER_VALUE, e.Text);
    };

    const handleOkOutletContent = () => {
        const totalCustomerCount = DBDetailActivity.reduce(
            (sum, row) => sum + (Number(row.Customer_Count) || 0),
            0
        );

        if (totalCustomerCount > targetOfActi) {
            toast.warning(
                "Actual No of Activities cannot be greater than target activation.",
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                }
            );
            return;
        }

        setOutletPopUp(false);

        if ((allDBActivity[0]?.PLANNING_STATUS == "A" && closerDate === 0)) {
            setAllDBActivity(prev =>
                prev.map(item => {
                    if (
                        item.Activity_Title === selectedActivityTitle &&
                        item.Qtr_ID.toString() === selectedQuarter.YEAR_QUARTER_VALUE &&
                        item.UNQ_ID.toString() === selectedUNQ_ID.toString()
                    ) {
                        return {
                            ...item,
                            Actual_Activation: totalCustomerCount,
                        };
                    }
                    return item;
                })
            );
        }
    };

    const handleCloseOutlet = () => {
        if ((allDBActivity[0]?.PLANNING_STATUS == "A" && closerDate === 0)) {
            setAllDBActivity(prev =>
                prev.map(item => {
                    if (
                        item.Activity_Title === selectedActivityTitle &&
                        item.Qtr_ID.toString() === selectedQuarter.YEAR_QUARTER_VALUE &&
                        item.UNQ_ID.toString() === selectedUNQ_ID.toString()
                    ) {
                        return {
                            ...item,
                            Actual_Activation: null,
                        };
                    }
                    return item;
                })
            );
        }
        setOutletPopUp(false);

    };

    const handleApproveKPIs = () => {
        const updated = allDBActivity.map((item) => {
            if (String(item.UNQ_ID) === String(selectedUNQMapID)) {
                return {
                    ...item,
                    KPI1_Approved: KPI1_Approved === "1" ? 1 : 0,
                    KPI2_Approved: KPI2_Approved === "1" ? 1 : 0,
                    KPI3_Approved: KPI3_Approved === "1" ? 1 : 0
                };
            }
            return item;
        });

        setAllDBActivity(updated);
        setKPIPopup(false);
    };



    const footerContentView = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-cancel-red" onClick={() => setViewPopup(false)}>Close</button>
            </div>
        </div>
    );
    const footerContentOutletView = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-primary" onClick={() => setViewOutletPopup(false)}>Ok</button>
                <button type="button" className="btn btn-cancel-red" onClick={() => setViewOutletPopup(false)}>Close</button>
            </div>
        </div>
    );

    const footerContentOutlet = (
        <div className="text-end">
            <button type="button" className="btn btn-primary me-2" onClick={() => handleOkOutletContent()}>Ok</button>
            <button type="button" className="btn btn-cancel-red" onClick={() => handleCloseOutlet()}>Close</button>
        </div>
    );

    const handlePidMapping = ()=>{
        let hasZeroValue = false;

        bulkActionRows.forEach((row) => {
            // Only check visible rows (rows with target count > 0)
            const targetCount = getTargetCount(row);
            if (targetCount === 0) return; // Skip channels not visible in bulk action

            let actualCount = 0;

            if (row._isOther) {
                const key = `${row?.UNQ_ID}__${row?.Channel_Desc}`;
                actualCount = channelActualOutletCounts[key] ?? 0;
            } else {
                const key = getMechanicConsumerKey(row);
                actualCount = Number(mechanicConsumerCounts[key]) || 0;
            }

            if (actualCount === 0) {
                hasZeroValue = true;
            }
        });

        if (hasZeroValue) {
            setPidmappingValidationPopup(true);
        } else {
            handleCheckBulkActionZeroValues();
        }
    };

    const handleCheckBulkActionZeroValues = () => {
        // Check if any channel has zero actual outlet count
        // Only check channels that are visible in the bulk action popup (Target Outlet Count > 0)
        setPidmappingValidationPopup(false);
        let hasZeroValue = false;

        bulkActionRows.forEach((row) => {
            // Only check visible rows (rows with target count > 0)
            const targetCount = getTargetCount(row);
            if (targetCount === 0) return; // Skip channels not visible in bulk action

            let actualCount = 0;

            if (row._isOther) {
                const key = `${row?.UNQ_ID}__${row?.Channel_Desc}`;
                actualCount = channelActualOutletCounts[key] ?? 0;
            } else {
                const key = getMechanicConsumerKey(row);
                actualCount = Number(mechanicConsumerCounts[key]) || 0;
            }

            if (actualCount === 0) {
                hasZeroValue = true;
            }
        });

        if (hasZeroValue) {
            setBulkActionZeroWarningPopup(true);
        } else {
            handleSaveBulkAction();
        }
    };

    const handleSaveBulkAction = () => {
        // Update allDBActivity with Actual Outlet Count values
        const updatedActivity = allDBActivity.map((activity) => {
            // Find all rows for this activity
            const activityRows = bulkActionRows.filter((row) => String(row.UNQ_ID) === String(activity.UNQ_ID));

            if (activityRows.length > 0) {
                // Calculate total actual outlet count for this activity
                const totalActualCount = activityRows.reduce((sum, row) => {
                    if (row._isOther) {
                        // For admin-mapped channels, get the actual outlet count from channelActualOutletCounts
                        const key = `${row?.UNQ_ID}__${row?.Channel_Desc}`;
                        return sum + (channelActualOutletCounts[key] ?? 0);
                    } else {
                        // For Mechanic/Consumer, use the count from mechanicConsumerCounts
                        const key = getMechanicConsumerKey(row);
                        return sum + (Number(mechanicConsumerCounts[key]) || 0);
                    }
                }, 0);

                return {
                    ...activity,
                    Actual_Activation: totalActualCount
                };
            }
            return activity;
        });

        setAllDBActivity(updatedActivity);

        toast.success("Actual No of Activities updated successfully.", {
            position: toast.POSITION.TOP_CENTER,
            pauseOnFocusLoss: false,
            closeButton: false,
            autoClose: 2000,
        });

        setBulkActionPopup(false);
        setBulkActionZeroWarningPopup(false);
    };

    const footerContentBulkAction = (
        <div>
            <div className="text-end">
                {canSubmitForApproval && <button type="button" className="btn btn-primary me-2" onClick={handlePidMapping}>Save</button>}
                <button type="button" className="btn btn-cancel-red" onClick={() => setBulkActionPopup(false)}>Close</button>
            </div>
        </div>
    );
    const handleDownloadPidMapping = () => {
        if (pidValidateRows.length === 0) {
            toast.warning("No data available to download.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }

        try {
            const wb = XLSX.utils.book_new();

            pidChannelNames.forEach((channelName) => {
                const channelRows = pidValidateRows.filter((r) => r.channelDesc === channelName);
                const exportData = channelRows.map((row) => ({
                    "Target Outlet Name": row.TargetOutletName || "",
                    "Target PID": row.TargetPID || "",
                    "Actual Outlet Name": row.ActualOutletName || "",
                    "Actual PID": row.ActualPID || "",
                    "Status": row.category === "matched" ? "Matched" : row.category === "addedByDistributor" ? "Added by Distributor" : "Pending DB Selection"
                }));

                const ws = XLSX.utils.json_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, ws, channelName.substring(0, 31)); // Sheet name limit is 31 chars
            });

            const fileName = `PID_Mapping_${pidValidateActivityTitle?.replace(/[^a-zA-Z0-9]/g, "_") || "Data"}_${formattedDate}.xlsx`;
            XLSX.writeFile(wb, fileName);

            toast.success("Excel downloaded successfully!", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } catch (error) {
            console.error("Download error:", error);
            toast.error("Failed to download Excel.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
    };

    const footerContentPidValidate = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-outline-primary me-2" onClick={handleDownloadPidMapping}>
                    <Fa.FaDownload className="me-1" /> PID Download Excel
                </button>
                {canSubmitForApproval && <button type="button" className="btn btn-primary me-2" onClick={handleSavePidValidation}>Save</button>}
                <button type="button" className="btn btn-cancel-red" onClick={handleClosePidValidate}>Close</button>
            </div>
        </div>
    );

    const footerContentKPI = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-primary me-2" onClick={handleApproveKPIs}>Yes</button>
                <button type="button" className="btn btn-cancel-red" onClick={() => setKPIPopup(false)}>No</button>
            </div>
        </div>
    );

    const footerContentZeroValueWarning = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-primary me-2" onClick={() => {
                    setZeroValueWarningPopup(false);
                    setSaveConfirmPopup(true);
                }}>Proceed</button>
                <button type="button" className="btn btn-cancel-red" onClick={() => setZeroValueWarningPopup(false)}>Close</button>
            </div>
        </div>
    );

    const footerContentBulkActionZeroWarning = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-primary me-2" onClick={() => {
                    setBulkActionZeroWarningPopup(false);
                    handleSaveBulkAction();
                }}>Proceed</button>
                <button type="button" className="btn btn-cancel-red" onClick={() => setBulkActionZeroWarningPopup(false)}>Close</button>
            </div>
        </div>
    );

    const footerContentPIDMapping = (
        <div>
            <div className="text-end">
                <button type="button" className="btn btn-primary me-2" onClick={() => handleCheckBulkActionZeroValues()}>Proceed</button>
                <button type="button" className="btn btn-cancel-red" onClick={() => setPidmappingValidationPopup(false)}>Close</button>
            </div>
        </div>
    );

    const handleSubmit = () => {
        setLoading(true);
        setSaveConfirmPopup(false);
        const lstDBActivityData = allDBActivity?.map((val) => ({
            dB_STATUS_ID: val?.DB_STATUS_ID?.toString(),
            dB_PLAN_ID: val?.DB_PLAN_ID?.toString(),
            unQ_ID: val?.UNQ_ID?.toString(),
            user_ID: val?.User_ID,
            qtr_ID: val?.Qtr_ID?.toString(),
            category_ID: val?.Category_ID?.toString(),
            category_Desc: val?.Category_Desc?.toString(),
            lbM_ID: val?.LBM_ID?.toString(),
            lbM_DESC: val?.LBM_DESC?.toString(),
            audience_ID: val?.Audience_ID?.toString(),
            audience_Desc: val?.Audience_Desc?.toString(),
            channel_ID: val?.Channel_ID?.toString(),
            channel_Desc: val?.Channel_Desc?.toString(),
            kpI1: val?.KPI1,
            kpI2: val?.KPI2,
            kpI3: val?.KPI3,
            activity_Title: val?.Activity_Title,
            activity_Desc: val?.Activity_Desc,
            comment: val?.Comment,
            caT_DEF_STATUS: val?.CAT_DEF_STATUS,
            max_Discount: val?.Max_Discount?.toString(),
            esT_BUDGET: val?.EST_BUDGET?.toString(),
            planninG_STATUS: val?.PLANNING_STATUS?.toString(),
            target_Activation: val?.Target_Activation?.toString(),
            actual_Activation: val?.Actual_Activation?.toString(),
            kpI1_Approved: val?.KPI1_Approved?.toString() ?? "0",
            kpI2_Approved: val?.KPI2_Approved?.toString() ?? "0",
            kpI3_Approved: val?.KPI3_Approved?.toString() ?? "0",
            stream_ID: val?.Stream_ID?.toString()
        }));
        const lstAllActivityChannelDetails = Object.values(DBDetailActivityHistory)
            .map((historyForRow) =>
                historyForRow.map((val) => ({
                    quarteR_ID: val?.QUARTER_ID?.toString(),
                    dB_CODE: val?.DB_CODE?.toString(),
                    categorY_DEF_ID: val?.CATEGORY_DEF_ID?.toString(),
                    seQ_ID: val?.SEQ_ID?.toString(),
                    activitY_TITLE: val?.ACTIVITY_TITLE?.toString(),
                    stream_Code: val?.Stream_Code?.toString(),
                    stream_Desc: val?.Stream_Desc?.toString(),
                    channel_Code: val?.Channel_Code?.toString(),
                    channel_Desc: val?.Channel_Desc?.toString(),
                    mappinG_CHECKBOX: val?.MAPPING_CHECKBOX?.toString(),
                    outleT_VIEW_CHECKBOX: val?.OUTLET_VIEW_CHECKBOX?.toString(),
                    channel_Discount: val?.Channel_Discount?.toString(),
                    customer_Count: isNewTemplate ? val?.Actual_Customer_Count?.toString() : val?.Customer_Count?.toString(),
                    customer_ID: isNewTemplate ? val?.Actual_Customer_ID : val?.Customer_ID,
                    actual_Customer_Count: val?.Actual_Customer_Count?.toString(),
                    actual_Customer_ID: val?.Actual_Customer_ID
                }))
            )
            .flat();

        const payload = {
            compId: auth?.CompId,
            userId: auth?.UserId,
            quarter: selectedQuarter?.YEAR_QUARTER_VALUE,
            lstDBActivityData: lstDBActivityData,
            lstAllActivityChannelDetails: lstAllActivityChannelDetails
        };


        console.log("Payload", payload);
        // return
        createAPIEndpointRNR()
            .post(`${EndpointSalesRNR.Save}`, JSON.stringify(payload), {
                headers: { "Content-Type": "application/json" },
            })
            .then((response) => {
                toast.success(response.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 4000,
                });
                createAPIEndpointRNR()
                    .get(`${EndpointSalesRNR.GetAllDBActivityData}?strcompid=${auth.CompId}&strQtrId=${selectedQuarter.YEAR_QUARTER_VALUE}&streamId=${selectedStream?.Value}`)
                    .then((res) => {
                        console.log("sdfsf", res.data.Data);
                        setAllDBActivity(res.data.Data);
                        setPlanningStatus(res.data.Data[0]?.PLANNING_STATUS);
                    })
                    .catch((e) => {
                        console.log("Error", e);
                    });

            })
            .catch((error) => {
                toast.error(error.response.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            })
            .finally(() => {
                setLoading(false);
            });

    };

    // useEffect(() => {
    //     if (!selectedRowKey) return;

    //     setDBDetailActivity(prev =>
    //         prev.map(row =>
    //             row.Channel_Code === selectedRowKey // or row.Channel_Desc === selectedRowKey
    //                 ? { ...row, Customer_Count: selectedOutlets1.length }
    //                 : row
    //         )
    //     );
    // }, [selectedOutlets1, selectedRowKey]);

    // const textEditor = (options) => {
    //     const { rowData, value, editorCallback } = options;

    //     if (rowData?.OUTLET_VIEW_CHECKBOX === 'Y') {
    //         // Show value, but do not allow edit
    //         editorCallback(value);
    //         return <span>{value}</span>;
    //     }

    //     return (
    //         <InputText
    //             type="number"
    //             value={value}
    //             onChange={(e) => editorCallback(e.target.value)}
    //             autoFocus
    //         />
    //     );
    // };


    const renderCustomerCountEditor = (rowData) => {
        const isEditing =
            editingRow === rowData?.Channel_Desc &&
            editingField === "Customer_Count";

        // If OUTLET_VIEW_CHECKBOX is "Y", just show the value
        if (rowData?.OUTLET_VIEW_CHECKBOX === "Y") {
            return <span>{rowData?.Customer_Count}</span>;
        }

        return isEditing ? (
            <InputText
                type="number"
                value={rowData?.Customer_Count === null ? "" : rowData?.Customer_Count}
                autoFocus
                onBlur={(e) => {
                    const rawVal = e.target.value;

                    // Revert to original if empty
                    const newVal = rawVal === "" ? rowData?.OriginalCustomerCount : Number(rawVal);

                    if (newVal < 0) {
                        toast.warn("Value cannot be negative", { position: toast.POSITION.TOP_CENTER, pauseOnFocusLoss: false, closeButton: false, autoClose: 2000 });
                        setEditingRow(null);
                        setEditingField(null);
                        return;
                    }

                    if (newVal > rowData?.OriginalCustomerCount) {
                        toast.warn(`Selection exceeds maximum allowed value. (${rowData?.OriginalCustomerCount})`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                        setEditingRow(null);
                        setEditingField(null);
                        return;
                    }

                    // Update DBDetailActivity
                    const updatedData = DBDetailActivity.map((item) =>
                        item.Channel_Desc === rowData.Channel_Desc
                            ? { ...item, Customer_Count: newVal }
                            : item
                    );
                    setDBDetailActivity(updatedData);

                    // Update history keyed by SEQ_ID
                    setDBDetailActivityHistory((hist) => ({
                        ...hist,
                        [rowData.SEQ_ID]: updatedData.filter((item) => item.SEQ_ID === rowData.SEQ_ID),
                    }));

                    setEditingRow(null);
                    setEditingField(null);
                }}
                onChange={(e) => {
                    const rawVal = e.target.value;

                    if (rawVal === "") {
                        const updatedData = DBDetailActivity.map((item) =>
                            item.Channel_Desc === rowData.Channel_Desc
                                ? { ...item, Customer_Count: "" }
                                : item
                        );
                        setDBDetailActivity(updatedData);

                        setDBDetailActivityHistory((hist) => ({
                            ...hist,
                            [rowData.SEQ_ID]: updatedData.filter((item) => item.SEQ_ID === rowData.SEQ_ID),
                        }));
                        return;
                    }

                    const inputValue = Number(rawVal);

                    if (inputValue < 0) {
                        toast.warn("Value cannot be negative", { position: toast.POSITION.TOP_CENTER, pauseOnFocusLoss: false, closeButton: false, autoClose: 2000 });
                        return;
                    }

                    if (inputValue > rowData?.OriginalCustomerCount) {
                        toast.warn(`Selection exceeds maximum allowed value. (${rowData?.OriginalCustomerCount})`, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                        return;
                    }

                    const updatedData = DBDetailActivity.map((item) =>
                        item.Channel_Desc === rowData.Channel_Desc
                            ? { ...item, Customer_Count: inputValue }
                            : item
                    );
                    setDBDetailActivity(updatedData);

                    setDBDetailActivityHistory((hist) => ({
                        ...hist,
                        [rowData.SEQ_ID]: updatedData.filter((item) => item.SEQ_ID === rowData.SEQ_ID),
                    }));
                }}
            />
        ) : (
            <span
                onClick={() => {
                    setEditingRow(rowData?.Channel_Desc);
                    setEditingField("Customer_Count");
                }}
                style={{ cursor: "pointer" }}
            >
                {rowData?.Customer_Count ?? "Click to edit"}
            </span>
        );
    };


    const renderCustomerCountBody = (rowData) => {
        return <span>{rowData.Actual_Customer_Count}</span>;
    };










    const onCellEditComplete = (e) => {
        const { rowData, newValue, field } = e;

        // If editing is disabled
        if (rowData?.OUTLET_VIEW_CHECKBOX === "Y") return;

        const updatedData = DBDetailActivity.map(item =>
            item.Channel_Desc === rowData.Channel_Desc
                ? { ...item, [field]: newValue }
                : item
        );

        setDBDetailActivity(updatedData);
        setDBDetailActivityHistory((hist) => [...hist, updatedData]);
    };


    const footerContent = (
        <div className="text-end">
            <button
                type="button"
                className="btn btn-primary me-3"
                onClick={() => {
                    handleSubmit();
                }}
            >
                Ok
            </button>
            <button
                type="button"
                className="btn btn-cancel-red"
                onClick={() => {
                    setSaveConfirmPopup(false);
                }}
            >
                Close
            </button>
        </div>
    );

    const pidChannelNames = Array.from(new Set(pidValidateRows.map((r) => r.channelDesc)));
    const pidRowMatchesFilter = (r) => {
        if (pidChannelFilter === "target") return r.category === "matched" || r.category === "pendingAsm";
        if (pidChannelFilter === "matched") return r.category === "matched";
        if (pidChannelFilter === "actual") return r.category === "matched" || r.category === "addedByDistributor";
        return true;
    };
    const pidStatusBody = (rowData) => {
        if (rowData?.category === "matched") {
            return (
                <span className="text-success">
                    <Fa.FaCheckCircle className="me-1" title="Set by ASM and confirmed by Distributor" />
                    Matched
                </span>
            );
        }
        if (rowData?.category === "addedByDistributor") {
            return (
                <span className="text-info">
                    <Fa.FaInfoCircle className="me-1" title="New outlet selected by Distributor, not set by ASM" />
                    Added by Distributor
                </span>
            );
        }
        return (
            <span className="text-warning">
                <Fa.FaExclamationCircle className="me-1" title="Set by ASM, pending Distributor selection" />
                Pending DB Selection
            </span>
        );
    };

    const handleDeleteActualOutlet = (rowData) => {
        setPidValidateRows((prev) => {
            if (rowData.category === "matched") {
                return prev.map((r) =>
                    r.CustomerID === rowData.CustomerID && r.channelDesc === rowData.channelDesc
                        ? { ...r, category: "pendingAsm", ActualOutletName: "", ActualPID: "" }
                        : r
                );
            }
            return prev.filter((r) => !(r.CustomerID === rowData.CustomerID && r.channelDesc === rowData.channelDesc));
        });
    };

    const pidActualOutletNameBody = (rowData) => (
        <div className="d-flex align-items-center justify-content-between">
            <span>{rowData.ActualOutletName}</span>
            {rowData.ActualOutletName && canSubmitForApproval && (
                <button
                    type="button"
                    className="grid-icon cancel ms-2"
                    title="Remove from Actual"
                    onClick={() => handleDeleteActualOutlet(rowData)}
                >
                    <Fa.FaTrash className="cancel" />
                </button>
            )}
        </div>
    );

   

    const bulkActionGroups = [];
    const bulkActionGroupIndexByUnqId = {};
    bulkActionRows.forEach((row) => {
        if (!(row.UNQ_ID in bulkActionGroupIndexByUnqId)) {
            bulkActionGroupIndexByUnqId[row.UNQ_ID] = bulkActionGroups.length;
            bulkActionGroups.push({
                UNQ_ID: row.UNQ_ID,
                Category_Desc: row.Category_Desc,
                Activity_Title: row.Activity_Title,
                Max_Discount: row.Max_Discount,
                EST_BUDGET: row.EST_BUDGET,
                rows: [],
            });
        }
        bulkActionGroups[bulkActionGroupIndexByUnqId[row.UNQ_ID]].rows.push(row);
    });

    if (loading) {
        return (
            <>
                <Loader />
            </>
        );
    }
    else {
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className='row d-flex justify-content-center align-items-center'>
                        <div className="col-lg-5 col-md-12 col-sm-12">
                            <h3 className="py-2">Rewards & Rebate book</h3>
                        </div>
                        <div className="col-lg-7 col-md-12 col-sm-12">
                            <div className='text-end'>
                                <small className='p-error'><i>Note: Achievement of all KPI(s) is mandatory for activity to be considered in target achievement.</i></small>
                            </div>
                        </div>
                    </div>

                    <section className="sales-box">
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">Stream <span className="mandatory">*</span></label>
                                <Dropdown
                                    value={selectedStream}
                                    onChange={(e) => handleStream(e.value)}
                                    options={stream}
                                    optionLabel="Text"
                                    required />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">Quarter <span className="mandatory">*</span></label>
                                <Dropdown
                                    value={selectedQuarter}
                                    onChange={(e) => handleQuarter(e.value)}
                                    options={quarter}
                                    optionLabel="YEAR_QUARTER_TEXT"
                                    required />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">                            <div className="text-end">
                                {(allDBActivity[0]?.PLANNING_STATUS == "A" && closerDate === 0) && <button type="button" className="btn btn-primary me-2" onClick={() => {
                                    const hasZeroValueActivity = allDBActivity?.some(
                                        (val) => Number(val?.Target_Activation) === 0 || Number(val?.Actual_Activation) === 0
                                    );
                                    if (hasZeroValueActivity) {
                                        setZeroValueWarningPopup(true);
                                    } else {
                                        setSaveConfirmPopup(true);
                                    }
                                }}>Submit for Approval</button>}
                                <button type="button" className="btn btn-primary" onClick={() => { handleDownload(); }}>{loadingExcel ? "Loading..." : "Download Excel"}{" "}
                                    {loadingExcel ? (
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        <Fa.FaDownload className="ms-2" />
                                    )}</button>
                            </div>
                            </div>
                        </div>
                    </section>
                    <section className="pb-4">
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="py-2">Records</h3>
                                <div className="d-flex align-items-center">
                                    <span className="me-2 fw-semibold small">Template:</span>
                                    <span className={`me-2 small ${isNewTemplate ? "text-success" : "text-secondary"}`}>
                                        {isNewTemplate ? "New" : "Old"}
                                    </span>
                                    <InputSwitch checked={isNewTemplate} onChange={() => { }} disabled />
                                    {isNewTemplate && (
                                        <button type="button" className="btn btn-primary ms-3" onClick={() => { openBulkActionDialog(); }}>
                                            Bulk Action
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="DataTable">
                                <DataTable
                                    paginator
                                    rows={10}
                                    // showGridlines
                                    // stripedRows
                                    scrollHeight="80vh"
                                    scrollable
                                    emptyMessage="No records found."
                                    rowsPerPageOptions={[10, 25, 50]}
                                    // tableStyle={{ minWidth: "80rem" }}
                                    value={allDBActivity}
                                >
                                    <Column field="Qtr_ID" header="Quarter"></Column>
                                    <Column field="Activity_Title" header="Activity Title"></Column>
                                    <Column field="Max_Discount" header="Categorywise Max Discount"></Column>
                                    <Column field="EST_BUDGET" header="Estimated Budget"></Column>
                                    <Column field="Target_Activation" header="Target activation"></Column>
                                    <Column field="Actual_Activation" header="Actual No of Activities"></Column>
                                    <Column body={renderActionKPI} header="KPI"></Column>
                                    {!isNewTemplate && <Column body={renderActionOUTLET} header="Outlets"></Column>}
                                    <Column body={renderAction} header="Action"></Column>
                                </DataTable>
                            </div>
                        </div>
                    </section>

                    {/* KPI Pop up strat*/}
                    <Dialog
                        header="Confirmation"
                        visible={KPIPopup}
                        style={{ width: "30vw" }}
                        closable={false}
                        draggable={false}
                        resizable={false}
                        footer={footerContentKPI}
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <ol className="list-group list-group-numbered">
                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">KPI 1</div>
                                        {KPI.KPI1}
                                    </div>
                                    <Checkbox
                                        value="1"
                                        onChange={(e) => setKPI1_Approved(e.checked ? "1" : "0")}
                                        checked={KPI1_Approved === "1"}
                                        disabled={!canSubmitForApproval}
                                    />

                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">KPI 2</div>
                                        {KPI.KPI2}
                                    </div>
                                    <Checkbox
                                        value="1"
                                        onChange={(e) => setKPI2_Approved(e.checked ? "1" : "0")}
                                        checked={KPI2_Approved === "1"}
                                        disabled={!canSubmitForApproval}
                                    />

                                </li>
                                <li className="list-group-item d-flex justify-content-between align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">KPI 3</div>
                                        {KPI.KPI3}
                                    </div>
                                    <Checkbox
                                        value="1"
                                        onChange={(e) => setKPI3_Approved(e.checked ? "1" : "0")}
                                        checked={KPI3_Approved === "1"}
                                        disabled={!canSubmitForApproval}
                                    />

                                </li>
                            </ol>
                        </div>
                    </Dialog>
                    {/* KPI Pop up strat*/}

                    {/* Outlet Pop up strat*/}
                    <Dialog
                        header="Activity Channel Details"
                        visible={outletPopUp}
                        style={{ width: "80vw" }}
                        closable={false}
                        draggable={false}
                        resizable={false}
                        footer={footerContentOutlet}
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable

                                    paginator
                                    rows={10}
                                    scrollHeight="80vh"
                                    scrollable
                                    emptyMessage="No records found."
                                    rowsPerPageOptions={[10, 25, 50]}
                                    value={DBDetailActivity}
                                    editMode="cell"
                                    onCellEditComplete={onCellEditComplete}
                                    data_key="Channel_Desc"
                                >
                                    <Column field="Channel_Desc" header="Channel Mapped By Admin"></Column>
                                    <Column field="Channel_Discount" header="Channel Discounts"></Column>
                                    <Column body={renderActionOutletView} header="Map Outlet"></Column>
                                    <Column
                                        field="Customer_Count"
                                        header="Target No Of Activation"
                                        body={(rowData) => {
                                            if (allDBActivity?.[0]?.PLANNING_STATUS === "A" && closerDate === 0) {
                                                return renderCustomerCountEditor(rowData);
                                            }
                                            return renderCustomerCountBody(rowData);
                                        }}

                                        style={{ minWidth: "10rem" }}
                                    />
                                </DataTable>
                            </div>
                        </div>
                    </Dialog>
                    {/* Outlet Pop up strat*/}

                    {/* ── Bulk Action Dialog  ──────────────────────────────────── */}
                    <Dialog
                        header="Bulk Action"
                        visible={bulkActionPopup}
                        style={{ width: "78vw" }}
                        closable={false}
                        draggable={false}
                        resizable={false}
                        className="bulk-action-dialog"
                        footer={footerContentBulkAction}
                    >
                        {bulkActionLoading ? (
                            <div className="bulk-action-loading">
                                <Fa.FaSpinner className="fa-spin me-2" />Loading data…
                            </div>
                        ) : (
                            <div className="bulk-action-content">
                                {bulkActionGroups.length === 0 ? (
                                    <div className="bulk-action-empty">No records found.</div>
                                ) : (
                                    bulkActionGroups.map((group) => {
                                        const otherRows = group.rows.filter((r) => r._isOther);
                                        const firstOtherRow = otherRows.find((r) => r._isFirstOther);
                                        const validatedTotal = otherRows.reduce(
                                            (sum, r) => sum + (channelActualOutletCounts[`${r.UNQ_ID}__${r.Channel_Desc}`] ?? 0),
                                            0
                                        );
                                        const hasAnyValidated = otherRows.some(
                                            (r) => `${r.UNQ_ID}__${r.Channel_Desc}` in channelActualOutletCounts
                                        );
                                        // Channels ASM never allocated a target to are irrelevant here — hide them.
                                        const visibleRows = group.rows.filter((r) => getTargetCount(r) > 0);
                                        const visibleOtherRows = visibleRows.filter((r) => r._isOther);
                                        // The shared textarea anchors to the first visible "other" row — recomputed
                                        // post-filter since the original _isFirstOther row may itself be hidden.
                                        const firstVisibleOtherRow = visibleOtherRows[0];

                                        return (
                                            <div key={group.UNQ_ID} className="bulk-action-card">
                                                {/* ── Card header ── */}
                                                <div className="bulk-action-card-header">
                                                    <div className="bulk-action-card-header-left">
                                                        <span>
                                                            <span className="bulk-action-field-label">Category: </span>
                                                            <span className="bulk-action-category-value">{group.Category_Desc}</span>
                                                        </span>
                                                        <span className="bulk-action-divider">|</span>
                                                        <span>
                                                            <span className="bulk-action-field-label">Activity: </span>
                                                            <span className="bulk-action-activity-value">{group.Activity_Title}</span>
                                                        </span>
                                                    </div>
                                                    <div className="bulk-action-card-header-right">
                                                        <div className="bulk-action-header-stats">
                                                            <span><span className="bulk-action-stat-label">Max Disc: </span><strong>{group.Max_Discount}</strong></span>
                                                            <span><span className="bulk-action-stat-label">Est Budget: </span><strong>{group.EST_BUDGET}</strong></span>
                                                        </div>
                                                        {firstOtherRow && (
                                                            <div className="bulk-action-header-actions">
                                                                {hasAnyValidated && (
                                                                    <span className="bulk-action-validated-badge">
                                                                        <Fa.FaCheckCircle className="bulk-action-validated-icon" />{validatedTotal} validated
                                                                    </span>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={() => { openPidValidateDialog(firstOtherRow); }}
                                                                >
                                                                    PID Mapping
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* ── Channel table — 5 cols ── */}
                                                <table className="bulk-action-table bulk-action-table--wide">
                                                    <colgroup>
                                                        <col className="bulk-action-col-channel" />
                                                        <col className="bulk-action-col-discount" />
                                                        <col className="bulk-action-col-target-count" />
                                                        <col className="bulk-action-col-actual-mapping" />
                                                        <col className="bulk-action-col-actual-count" />
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th className="bulk-action-th">Channel</th>
                                                            <th className="bulk-action-th bulk-action-th-right">Channel Discount</th>
                                                            <th className="bulk-action-th bulk-action-th-right">Target Outlet Count</th>
                                                            <th className="bulk-action-th">Actual Outlet Mapping</th>
                                                            <th className="bulk-action-th bulk-action-th-right">Actual Outlet Count</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {visibleRows.map((rowData, idx) => {
                                                            const isFirstVisibleOther = rowData === firstVisibleOtherRow;
                                                            const targetCount = getTargetCount(rowData) || 0;
                                                            const actualCount = !rowData?._isOther
                                                                ? (mechanicConsumerCounts[getMechanicConsumerKey(rowData)] || "")
                                                                : (channelActualOutletCounts[`${rowData?.UNQ_ID}__${rowData?.Channel_Desc}`] ?? "");

                                                            // Row styling: dashed mechanic/consumer rows get badges, like the reference;
                                                            // plain channel ("other") rows get the standard zebra striping.
                                                            const rowClassName = rowData._isMechanic
                                                                ? "bulk-action-row-mechanic"
                                                                : rowData._isConsumer
                                                                    ? "bulk-action-row-consumer"
                                                                    : idx % 2 === 0
                                                                        ? "bulk-action-row-even"
                                                                        : "bulk-action-row-odd";

                                                            return (
                                                                <tr key={`${rowData.UNQ_ID}__${rowData.Channel_Desc}`} className={rowClassName}>
                                                                    <td className="bulk-action-td">
                                                                        {rowData._isMechanic ? (
                                                                            <span className="bulk-action-badge bulk-action-badge-mechanic">Mechanic</span>
                                                                        ) : rowData._isConsumer ? (
                                                                            <span className="bulk-action-badge bulk-action-badge-consumer">Consumer</span>
                                                                        ) : (
                                                                            <span className="bulk-action-channel-name">{rowData.Channel_Desc}</span>
                                                                        )}
                                                                    </td>

                                                                    <td className="bulk-action-td bulk-action-td-right">
                                                                        <span className="bulk-action-value-readonly">{rowData.Channel_Discount}</span>
                                                                    </td>

                                                                    <td className="bulk-action-td bulk-action-td-right">
                                                                        <span className="bulk-action-value-target">{targetCount || "—"}</span>
                                                                    </td>

                                                                    {!rowData?._isOther ? (
                                                                        <td className="bulk-action-td">
                                                                            <input
                                                                                type="number"
                                                                                className="form-control form-control-sm bulk-action-input-target"
                                                                                value={mechanicConsumerCounts[getMechanicConsumerKey(rowData)] ?? ""}
                                                                                onChange={(e) => handleMechanicConsumerCountChange(rowData, e.target.value)}
                                                                                placeholder="Enter count"
                                                                                disabled={!canSubmitForApproval}
                                                                                readOnly={!canSubmitForApproval}
                                                                            />
                                                                        </td>
                                                                    ) : isFirstVisibleOther ? (
                                                                        <td className="bulk-action-td bulk-action-td-top bulk-action-td-textarea" rowSpan={visibleOtherRows.length}>
                                                                            <textarea
                                                                                className="form-control form-control-sm bulk-action-pid-textarea"
                                                                                rows={Math.max(4, visibleOtherRows.length * 2)}
                                                                                placeholder="Outlet name(s), comma or newline separated"
                                                                                value={actualOutletMappingText[getActivityKey(rowData)] ?? ""}
                                                                                onChange={(e) => handleActualOutletMappingChange(rowData, e.target.value)}
                                                                                readOnly={!canSubmitForApproval}
                                                                            />
                                                                        </td>
                                                                    ) : null}

                                                                    <td className={`bulk-action-td bulk-action-td-right bulk-action-count ${actualCount ? "bulk-action-count--active-green" : "bulk-action-count--inactive"}`}
                                                                    >
                                                                        {actualCount || "—"}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        )}
                    </Dialog>
                    {/* ── Bulk Action Dialog  ──────────────────────────────────── */}

                    {/* ── PID Validate and View Mapping Dialog ─────────────────────────── */}
                    <Dialog
                        header={`PID Validate and View Mapping${pidValidateActivityTitle ? " - " + pidValidateActivityTitle : ""}`}
                        visible={pidValidatePopup}
                        style={{ width: "70vw" }}
                        closable={false}
                        draggable={false}
                        resizable={false}
                        footer={footerContentPidValidate}
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            {pidValidateLoading ? (
                                <div className="text-center py-3">
                                    <Fa.FaSpinner className="fa-spin me-2" />Loading outlet data...
                                </div>
                            ) : (
                                <>
                                    <div className="TabPanel">
                                        <TabView
                                            activeIndex={activePidTabIndex}
                                            onTabChange={(e) => { setActivePidTabIndex(e.index); setPidChannelFilter("all"); }}
                                        >
                                            {pidChannelNames.map((channelName) => {
                                                const channelRows = pidValidateRows.filter((r) => r.channelDesc === channelName);
                                                const targetCount = channelRows.filter((r) => r.category === "matched" || r.category === "pendingAsm").length;
                                                const matchedCount = channelRows.filter((r) => r.category === "matched").length;
                                                const actualCount = channelRows.filter((r) => r.category === "matched" || r.category === "addedByDistributor").length;
                                                const filteredRows = channelRows.filter(pidRowMatchesFilter);
                                                return (
                                                    <TabPanel key={channelName} header={`${channelName} (${channelRows.length})`}>
                                                        <div className="mb-3 d-flex flex-wrap gap-2">
                                                            <button
                                                                type="button"
                                                                className={`btn btn-sm ${pidChannelFilter === "all" ? "btn-primary" : "btn-outline-secondery"}`}
                                                                onClick={() => setPidChannelFilter("all")}
                                                            >
                                                                All ({channelRows.length})
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={`btn btn-sm ${pidChannelFilter === "target" ? "btn-primary" : "btn-outline-secondery"}`}
                                                                onClick={() => setPidChannelFilter("target")}
                                                            >
                                                                Target ({targetCount})
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={`btn btn-sm ${pidChannelFilter === "matched" ? "btn-primary" : "btn-outline-secondery"}`}
                                                                onClick={() => setPidChannelFilter("matched")}
                                                            >
                                                                Matched ({matchedCount})
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={`btn btn-sm ${pidChannelFilter === "actual" ? "btn-primary" : "btn-outline-secondery"}`}
                                                                onClick={() => setPidChannelFilter("actual")}
                                                            >
                                                                Actual ({actualCount})
                                                            </button>
                                                        </div>
                                                        <div className="DataTable">
                                                            <DataTable
                                                                paginator
                                                                rows={10}
                                                                rowsPerPageOptions={[10, 25, 50]}
                                                                scrollHeight="50vh"
                                                                scrollable
                                                                showGridlines
                                                                stripedRows
                                                                emptyMessage="No outlets found."
                                                                value={filteredRows}
                                                            >
                                                                <Column field="TargetOutletName" header="Target Outlet Name"></Column>
                                                                <Column field="TargetPID" header="Target PID"></Column>
                                                                <Column header="Actual Outlet Name" body={pidActualOutletNameBody}></Column>
                                                                <Column field="ActualPID" header="Actual PID"></Column>
                                                                <Column header="Status" body={pidStatusBody}></Column>
                                                            </DataTable>
                                                        </div>
                                                    </TabPanel>
                                                );
                                            })}
                                        </TabView>
                                    </div>
                                    {invalidActualOutletEntries.length > 0 && (
                                        <div className="mt-3">
                                            <label className="form-label">Invalid Entries (Not Recognized For This Distributor)</label>
                                            <div className="DataTable">
                                                <DataTable
                                                    value={invalidActualOutletEntries.map((entry) => ({ entry }))}
                                                    showGridlines
                                                    stripedRows
                                                    scrollable
                                                    scrollHeight="200px"
                                                    emptyMessage="No invalid entries."
                                                >
                                                    <Column field="entry" header="Entered Value"></Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </Dialog>
                    {/* ── PID Validate and View Mapping Dialog ─────────────────────────── */}

                    {/* View Pop up strat*/}
                    <Dialog
                        header="Information"
                        visible={viewPopup}
                        style={{ width: "80vw" }}
                        closable={false}
                        draggable={false}
                        resizable={false}
                        footer={footerContentView}
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    paginator
                                    rows={10}
                                    scrollHeight="80vh"
                                    scrollable
                                    emptyMessage="No records found."
                                    rowsPerPageOptions={[10, 25, 50]}
                                    value={viewItem}
                                >
                                    <Column field="Category_Desc" header="Category"></Column>
                                    <Column field="Audience_Desc" header="Audience"></Column>
                                    <Column field="Channel_Desc" header="Channel"></Column>
                                    <Column field="LBM_DESC" header="LBM"></Column>
                                    <Column field="KPI1" header="KPI1"></Column>
                                    <Column field="KPI2" header="KPI2"></Column>
                                    <Column field="KPI3" header="KPI3"></Column>
                                    <Column field="Activity_Title" header="Activity Title"></Column>
                                </DataTable>
                            </div>
                        </div>
                    </Dialog>
                    {/* View Pop up strat*/}
                    <Dialog
                        header="Warning"
                        visible={zeroValueWarningPopup}
                        style={{ width: "40vw" }}
                        closable={false}
                        resizable={false}
                        draggable={false}
                        footer={footerContentZeroValueWarning}
                    >
                        <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                            <p className="text-warning">
                                <Fa.FaExclamationTriangle className="me-2" style={{ fontSize: "1.5rem" }} />
                                Your activity have zero value which can impact in payout. Do you want to proceed?
                            </p>
                        </div>
                    </Dialog>
                    <Dialog
                        header="Warning"
                        visible={bulkActionZeroWarningPopup}
                        style={{ width: "40vw" }}
                        closable={false}
                        resizable={false}
                        draggable={false}
                        footer={footerContentBulkActionZeroWarning}
                    >
                        <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                            <p className="text-warning">
                                <Fa.FaExclamationTriangle className="me-2" style={{ fontSize: "1.5rem" }} />
                                Your activity have zero value which can impact in payout. Do you want to proceed?
                            </p>
                        </div>
                    </Dialog>
                    <Dialog
                        header="Information"
                        visible={saveConfirmPopup}
                        style={{ width: "40vw" }}
                        closable={false}
                        resizable={false}
                        draggable={false}
                        footer={footerContent}
                    >
                        <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                            <p>Have you entered data in Actual No of Activation field and select KPI(s)? Please confirm.</p>
                        </div>

                    </Dialog>
                    <Dialog
                        header="Information"
                        visible={viewOutletPopup}
                        style={{ width: "80vw" }}
                        closable={false}
                        draggable={false}
                        resizable={false}
                        footer={footerContentOutletView}
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    value={viewOutlet}
                                    paginator
                                    selection={selectedOutlets}
                                    onSelectionChange={(e) => {
                                        // Prevent selection changes if user cannot submit for approval
                                        if (!canSubmitForApproval) {
                                            return;
                                        }

                                        const selected = e.value;
                                        const maxAllowed = Number(selectedRowData ?? 0);

                                        // Prevent exceeding max allowed
                                        if (selected.length > maxAllowed) {
                                            toast.warn(
                                                `Selection exceeds maximum allowed channel discount. (${maxAllowed})`,
                                                {
                                                    position: toast.POSITION.TOP_CENTER,
                                                    pauseOnFocusLoss: false,
                                                    closeButton: false,
                                                    autoClose: 2000,
                                                }
                                            );
                                            return;
                                        }

                                        setSelectedOutlets(selected);

                                        if (selectedRowKey) {
                                            setDBDetailActivity((prev) => {
                                                const updatedData = prev.map((row) =>
                                                    row.Channel_Desc === selectedRowKey
                                                        ? {
                                                            ...row,
                                                            Customer_Count: selected.length,
                                                            Customer_ID: selected.map((c) => c.CustomerID).join("~"),
                                                        }
                                                        : row
                                                );

                                                setDBDetailActivityHistory((hist) => {
                                                    const seqId = updatedData.find((r) => r.Channel_Desc === selectedRowKey)?.SEQ_ID;
                                                    return {
                                                        ...hist,
                                                        [seqId]: updatedData.filter((r) => r.SEQ_ID === seqId),
                                                    };
                                                });

                                                return updatedData;
                                            });
                                        }
                                    }}
                                    showSelectAll={false}
                                    rows={10}
                                    filterDisplay="row"
                                    rowsPerPageOptions={[10, 25, 50]}
                                    scrollHeight="80vh"
                                    showGridlines
                                    selectionMode={canSubmitForApproval ? "checkbox" : null}
                                    scrollable
                                    stripedRows
                                    emptyMessage="No Record found"
                                >
                                    <Column
                                        selectionMode="multiple"
                                        headerStyle={{ width: "3em" }}
                                    />
                                    <Column
                                        field="CustomerName"
                                        header="List of Outlets"
                                        style={{ minWidth: "17rem" }}
                                        filter
                                        filterMatchMode="contains"
                                        filterPlaceholder="Search Here..."
                                    />
                                </DataTable>

                            </div>
                        </div>
                    </Dialog >
                    <Dialog
                        header="Info"
                        visible={pidmappingValidationPopup}
                        style={{ width: "40vw" }}
                        closable={false}
                        resizable={false}
                        draggable={false}
                        footer={footerContentPIDMapping}
                    >
                        <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                            <p className="text-info">
                                <Fa.FaInfoCircle className="me-2" style={{ fontSize: "1.5rem" }} />
                             Before proceeding, make sure you validate the PIDs by clicking PID Mapping.
                            </p>
                        </div>
                    </Dialog>
                </div >
            </>
        );
    }

};

export default RewardsRebatebook;
